var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisualisationResetAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_17365_100281)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0376 15.2324C35.5255 15.2324 35.1032 15.6053 35.1032 16.1219C35.0583 19.4869 33.1175 22.5283 30.1479 24.1591C25.6733 26.6166 20.444 24.4107 18.4403 21.4187L21.2661 22.0072C21.7333 22.1016 22.2455 21.8185 22.3398 21.3064C22.4342 20.8391 22.1511 20.327 21.639 20.2326L16.0817 19.0646C15.7582 18.9882 14.9091 19.2218 15.008 20.0934L15.7088 25.7001C15.7537 26.1673 16.1311 26.4953 16.5983 26.4953C17.2947 26.4953 17.5777 25.9831 17.5328 25.4665L17.2048 22.7305C21.7468 28.18 27.5108 27.4208 30.988 25.8439C34.5865 23.9255 36.8778 20.2371 36.9227 16.1669C36.9272 15.6547 36.5498 15.2324 36.0376 15.2324Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8934 16.7649C16.4056 16.7649 16.8279 16.392 16.8279 15.8753C16.8728 12.5104 18.8136 9.46893 21.7832 7.83813C26.2578 5.3807 31.4871 7.58655 33.4908 10.5786L30.665 9.99007C30.1978 9.89572 29.6856 10.1788 29.5913 10.6909C29.4969 11.1581 29.78 11.6703 30.2921 11.7646L35.8539 12.9327C36.1774 13.0091 37.0265 12.7755 36.9276 11.9039L36.2268 6.29718C36.1819 5.82995 35.8045 5.502 35.3373 5.502C34.6409 5.502 34.3579 6.01415 34.4028 6.53079L34.7263 9.26677C30.1843 3.82178 24.4203 4.57653 20.9431 6.15791C17.3445 8.07174 15.0533 11.7646 15.0039 15.8304C15.0039 16.347 15.3813 16.7649 15.8934 16.7649Z",
    fill: "#232F6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_17365_100281",
    x: -4,
    y: -14,
    width: 60,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17365_100281"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5525 0 0 0 0 0.56225 0 0 0 0 0.65 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_17365_100281",
    result: "effect2_dropShadow_17365_100281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17365_100281",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualisationResetAction);
export default __webpack_public_path__ + "static/media/visualisation-reset-action.50de25f3a938631fd088f166a7959fdc.svg";
export { ForwardRef as ReactComponent };